import httpClient from '@/apis/base/httpclient';
import BaseAPI from '@/apis/base/baseApi';
class AuditingLogAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = 'TaskGo';
  controllerName = 'AuditingLog';
  /**
   * Lưu thông tin auditing log
   * @param {*} param
   * @returns
   */
  Insert(param) {
    let request = { url: this.getAPIUrl(), data: param };
    return httpClient.postAsync(request, true);
  }
}

export default new AuditingLogAPI();
